import { render, staticRenderFns } from "./zbhd.vue?vue&type=template&id=49bf1ec5&scoped=true"
import script from "./zbhd.vue?vue&type=script&lang=js"
export * from "./zbhd.vue?vue&type=script&lang=js"
import style0 from "./zbhd.vue?vue&type=style&index=0&id=49bf1ec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bf1ec5",
  null
  
)

export default component.exports